// extracted by mini-css-extract-plugin
module.exports = {"shadowBlock":"QAOyK"};